import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import { useLibrary } from '../contexts/LibraryContext';
interface SaveButtonProps {
  id: string;
  label: string;
  variant?: 'full' | 'icon';
}
export function SaveButton({
  id,
  label,
  variant = 'full'
}: SaveButtonProps) {
  const {
    isFavorite,
    toggleFavorite
  } = useLibrary();
  const saved = isFavorite(id);
  if (variant === 'icon') {
    return <motion.button type="button" onClick={event => {
      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(id);
    }} aria-pressed={saved} aria-label={saved ? `Remove ${label} from favorites` : `Save ${label} to favorites`} whileTap={{
      scale: 0.86
    }} animate={saved ? {
      scale: [1, 1.22, 1]
    } : {
      scale: 1
    }} transition={{
      duration: 0.26,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-lav-dim transition-colors duration-200 ease-smooth hover:border-aura/50 hover:text-aura-bright focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70" data-id="element-71" data-mp="1er7cbq4bmw9p">
        <HeartIcon className={saved ? 'h-4 w-4 text-aura-bright' : 'h-4 w-4'} strokeWidth={1.9} fill={saved ? 'currentColor' : 'none'} data-id="element-72" data-mp="fjl1zdwyqh6g" />
      </motion.button>;
  }
  return <motion.button type="button" onClick={() => toggleFavorite(id)} aria-pressed={saved} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.16,
    ease: [0.23, 1, 0.32, 1]
  }} className={['flex w-full items-center justify-center gap-2.5 rounded-2xl border px-5 py-4 text-[15px] font-semibold tracking-tight transition-[background-color,border-color,box-shadow,color] duration-200 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70', saved ? 'border-aura-bright/50 bg-aura/20 text-white shadow-[0_0_28px_-8px_rgba(139,92,246,0.85)]' : 'border-white/12 bg-white/[0.05] text-white hover:border-aura/60 hover:shadow-[0_0_26px_-8px_rgba(139,92,246,0.8)]'].join(' ')} data-id="element-73" data-mp="5o02pnja3v0e">
      <motion.span animate={saved ? {
      scale: [1, 1.28, 1]
    } : {
      scale: 1
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex items-center" data-id="element-74" data-mp="36k25ep8afn9e">
        <HeartIcon className={saved ? 'h-[18px] w-[18px] text-aura-bright' : 'h-[18px] w-[18px] text-lav'} strokeWidth={1.9} fill={saved ? 'currentColor' : 'none'} data-id="element-75" data-mp="33217zhibwqx" />
      </motion.span>
      {saved ? `Saved ${label}` : `Save ${label}`}
    </motion.button>;
}